import React, { useRef } from 'react';

type Props = {
  title: string;
  message: string;
  closeLabel: string;
  onClose?: () => void;
};

function ErrorPopup({ title, message, closeLabel, onClose }: Props) {
  const popupRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <div className="medispa-calendar_error-popup-backdrop"></div>
      <div ref={popupRef} className="medispa-calendar_error-popup">
        <button
          type="button"
          className="medispa-calendar_error-popup_close"
          onClick={() => {
            onClose?.();
          }}
        >
          <svg
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.782 7.31714L6.82883 20.2703"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
            ></path>
            <path
              d="M20.0137 20.2637L7.06052 7.31052"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
            ></path>
          </svg>
        </button>
        <h1 className="medispa-calendar_error-popup_title">{title}</h1>
        <p className="medispa-calendar_error-popup_message">{message}</p>
        <button
          type="button"
          className="medispa-calendar_error-popup_close-cta"
          onClick={() => {
            onClose?.();
          }}
        >
          {closeLabel}
        </button>
      </div>
    </>
  );
}

export default ErrorPopup;
